import * as React from 'react';
import classnames from 'classnames';
import Base, { Props as BaseProps } from '../Base/Base';
import './Link.css';

export type TypeLinkColor = 'grape-3' | 'grape-5' | 'gray-1' | 'gray-5' | 'white';

export interface Props extends BaseProps {
  /** A subset of the base level color that has interaction styling */
  color?: TypeLinkColor;
  /** Applies an underline styling to the link */
  underline?: boolean;
}

/** Styled link component */
const Link: React.FunctionComponent<Props> = (props: Props) => {
  const { className, color, underline, ...rest } = props;
  const classes = classnames(className, 'Link', `Link--color-${color}`, {
    'Link--underline': underline,
  });

  return (
    <Base { ...rest } className={ classes } />
  );
};

Link.defaultProps = {
  Component: 'a',
};

export default Link;
